// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.report-oc-wrapper {
  height: 190px;
}

.elc-report-header {
  font-size: 12px;
  font-weight: 500;
}

.elc-report-search, .elc-report-select {
  border-color: #d3d3d3;
  height: 30px;
  width: 190px;
  font-size: 12px;
}

.elc-report-select {
  padding: 5px;
}

.elc-button-group-single {
  background-color: #fff;
  color: #000;
  border: 1px solid #d3d3d3;
  border-radius: 0;
}

.elc-button-group-left {
  border-radius: 5px 0 0 5px;
  border-right: 0;
}

.elc-button-group-right {
  border-radius: 0 5px 5px 0;
  border-left: 0;
}

.elc-button-group-single:hover, .elc-create:hover, .elc-filter:hover {
  background-color: #f5f5f5;
}

.elc-create {
  background-color: #0A65CC;
  color: #fff;
  font-weight: 500;
}

.elc-filter {
  background-color: #fff;
  color: #000;
  border: 1px solid #d3d3d3;
}`, "",{"version":3,"sources":["webpack://./../dashboard/src/components/ELCTable/DynamicTableWrapper.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;AACJ;;AAEA;EACI,eAAA;EACA,gBAAA;AACJ;;AAEA;EACI,qBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAIA;EACI,sBAAA;EACA,WAAA;EACA,yBAAA;EACA,gBAAA;AADJ;;AAIA;EACI,0BAAA;EACA,eAAA;AADJ;;AAIA;EACI,0BAAA;EACA,cAAA;AADJ;;AAIA;EACI,yBAAA;AADJ;;AAIA;EACI,yBAAA;EACA,WAAA;EACA,gBAAA;AADJ;;AAIA;EACI,sBAAA;EACA,WAAA;EACA,yBAAA;AADJ","sourcesContent":[".report-oc-wrapper {\n    height: 190px;\n}\n\n.elc-report-header {\n    font-size: 12px;\n    font-weight: 500;\n}\n\n.elc-report-search, .elc-report-select {\n    border-color: #d3d3d3;\n    height: 30px;\n    width: 190px;\n    font-size: 12px;\n}\n\n.elc-report-select {\n    padding: 5px;\n}\n\n// Buttons\n\n.elc-button-group-single {\n    background-color: #fff;\n    color: #000;\n    border: 1px solid #d3d3d3;\n    border-radius: 0;\n}\n\n.elc-button-group-left {\n    border-radius: 5px 0 0 5px;\n    border-right: 0;\n}\n\n.elc-button-group-right {\n    border-radius:  0 5px 5px 0;\n    border-left: 0;\n}\n\n.elc-button-group-single:hover, .elc-create:hover, .elc-filter:hover {\n    background-color: #f5f5f5;\n}\n\n.elc-create {\n    background-color: #0A65CC;\n    color: #fff;\n    font-weight: 500;\n}\n\n.elc-filter {\n    background-color: #fff;\n    color: #000;\n    border: 1px solid #d3d3d3;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
